<template>
  <div>
    <!-- 列表对话框 -->
    <el-dialog
      title="交通方式"
      :visible.sync="listVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div v-loading="listLoading" class="transportation-list">
        <!-- 表头 -->
        <div class="transportation-header">
          <div class="header-cell" style="width: 100px;">姓名</div>
          <div class="header-cell" style="width: 80px;">性别</div>
          <div class="header-cell" style="width: 130px;">预报名者关系</div>
          <div class="header-cell" style="width: 200px;">身份证号码</div>
          <div class="header-cell" style="width: 150px;">手机号码</div>
          <div class="header-cell" style="width: 120px;">交通信息</div>
          <div class="header-cell" style="width: 180px;">登记时间</div>
          <div class="header-cell" style="width: 150px;">操作</div>
        </div>
        <!-- 表体 -->
        <div class="transportation-body">
          <div
            v-for="(parent, parentIndex) in groupedList"
            :key="parentIndex"
            class="transportation-row-wrapper"
          >
            <!-- 成人行 -->
            <div
              class="transportation-row parent-row"
              :class="{ 'row-even': parentIndex % 2 === 1 }"
            >
              <div class="body-cell" style="width: 100px;">
                <div class="cell-content">
                  <span class="name-info">{{ parent.realName }}</span>
                </div>
              </div>
              <div class="body-cell" style="width: 80px;">
                <div class="cell-content">
                  {{ parent.sex === 1 ? "男" : parent.sex === 2 ? "女" : "-" }}
                </div>
              </div>
              <div class="body-cell" style="width: 130px;">
                <div class="cell-content">{{ parent.relationship || "-" }}</div>
              </div>
              <div class="body-cell" style="width: 200px;">
                <div class="cell-content">
                  {{ parent.idCardNo }}(成人)
                </div>
              </div>
              <div class="body-cell" style="width: 150px;">
                <div class="cell-content">{{ parent.mobile }}</div>
              </div>
              <div class="body-cell" style="width: 120px;">
                <div class="cell-content">
                  {{ parent.isSubmitTransportation ? "已登记" : "未登记" }}
                </div>
              </div>
              <div class="body-cell" style="width: 180px;">
                <div class="cell-content">{{ parent.operatedTime || "-" }}</div>
              </div>
              <div class="body-cell" style="width: 150px;">
                <div class="cell-content">
                  <el-button
                    type="text"
                    @click="handleViewTransportation(parent)"
                  >
                    交通信息
                  </el-button>
                </div>
              </div>
            </div>
            <!-- 儿童行 -->
            <div
              v-if="parent.children && parent.children.length > 0"
              class="child-rows-wrapper"
            >
              <div
                v-for="(child, childIndex) in parent.children"
                :key="childIndex"
                class="transportation-row child-row"
              >
                <div class="body-cell">
                  <div class="cell-content">
                    <span>{{
                      child.relationship
                        ? `${child.realName} (${child.relationship})`
                        : child.realName
                    }}</span>
                    <span>
                      {{
                        child.sex === 1 ? "男" : child.sex === 2 ? "女" : "-"
                      }}</span
                    >
                  </div>
                </div>
                <div class="body-cell">
                  <div class="cell-content">-</div>
                </div>
                <div class="body-cell">
                  <div class="cell-content">
                    {{ maskIdCard(child.idCardNo) }}(儿童)
                  </div>
                </div>
                <div class="body-cell">
                  <div class="cell-content">{{ maskMobile(child.mobile) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="groupedList.length === 0" class="empty-data">暂无数据</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="listVisible = false">返回</el-button>
      </div>
    </el-dialog>

    <!-- 交通信息详情对话框 -->
    <el-dialog
      :title="`交通信息 - ${currentPersonName || ''}`"
      :visible.sync="detailVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div v-loading="detailLoading">
        <!-- 去程交通方式 -->
        <div class="transportation-section">
          <div class="section-title">
            <span>去程交通方式</span>
            <el-button
              type="primary"
              size="small"
              @click="handleAdd('departure', null)"
            >
              添加去程
            </el-button>
          </div>
          <div class="transportation-table">
            <div class="table-header">
              <div class="header-cell" style="width: 80px;">行程</div>
              <div class="header-cell" style="width: 120px;">交通方式</div>
              <div class="header-cell" style="width: 150px;">车次号/航班号</div>
              <div class="header-cell" style="width: 150px;">凭证</div>
              <div class="header-cell" style="width: 180px;">登记时间</div>
              <div class="header-cell" style="flex: 1;">操作</div>
            </div>
            <div class="table-body">
              <div
                v-for="(item, index) in departureList"
                :key="index"
                class="table-row"
              >
                <div class="body-cell" style="width: 80px;">
                  <div class="cell-content">{{ index + 1 }}程</div>
                </div>
                <div class="body-cell" style="width: 120px;">
                  <div class="cell-content">{{ item.means || "-" }}</div>
                </div>
                <div class="body-cell" style="width: 150px;">
                  <div class="cell-content">
                    {{ item.trainOrFlight || "-" }}
                  </div>
                </div>
                <div class="body-cell" style="width: 150px;">
                  <div class="cell-content voucher-images">
                    <template v-if="item.vouchersUrl">
                      <el-image
                        v-for="(url, imgIndex) in item.vouchersUrl
                          .split(',')
                          .filter(Boolean)"
                        :key="imgIndex"
                        :src="url"
                        :preview-src-list="
                          item.vouchersUrl.split(',').filter(Boolean)
                        "
                        fit="cover"
                        class="voucher-thumbnail"
                        :initial-index="imgIndex"
                      >
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="body-cell" style="width: 180px;">
                  <div class="cell-content">{{ item.arrivalTime || "-" }}</div>
                </div>
                <div class="body-cell" style="flex: 1;">
                  <div class="cell-content">
                    <el-button
                      type="text"
                      @click="handleEdit(item, 'departure')"
                    >
                      编辑
                    </el-button>
                    <el-button type="text" @click="handleDelete(item)">
                      删除
                    </el-button>
                  </div>
                </div>
              </div>
              <div v-if="departureList.length === 0" class="empty-row">
                <div class="cell-content">暂无数据</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 返程交通方式 -->
        <div class="transportation-section" style="margin-top: 30px;">
          <div class="section-title">
            <span>返程交通方式</span>
            <el-button
              type="primary"
              size="small"
              @click="handleAdd('return', null)"
            >
              添加返程
            </el-button>
          </div>
          <div class="transportation-table">
            <div class="table-header">
              <div class="header-cell" style="width: 80px;">行程</div>
              <div class="header-cell" style="width: 120px;">交通方式</div>
              <div class="header-cell" style="width: 150px;">车次号/航班号</div>
              <div class="header-cell" style="width: 150px;">凭证</div>
              <div class="header-cell" style="width: 180px;">登记时间</div>
              <div class="header-cell" style="flex: 1;">操作</div>
            </div>
            <div class="table-body">
              <div
                v-for="(item, index) in returnList"
                :key="index"
                class="table-row"
              >
                <div class="body-cell" style="width: 80px;">
                  <div class="cell-content">{{ index + 1 }}程</div>
                </div>
                <div class="body-cell" style="width: 120px;">
                  <div class="cell-content">{{ item.means || "-" }}</div>
                </div>
                <div class="body-cell" style="width: 150px;">
                  <div class="cell-content">
                    {{ item.trainOrFlight || "-" }}
                  </div>
                </div>
                <div class="body-cell" style="width: 150px;">
                  <div class="cell-content voucher-images">
                    <template v-if="item.vouchersUrl">
                      <el-image
                        v-for="(url, imgIndex) in item.vouchersUrl
                          .split(',')
                          .filter(Boolean)"
                        :key="imgIndex"
                        :src="url"
                        :preview-src-list="
                          item.vouchersUrl.split(',').filter(Boolean)
                        "
                        fit="cover"
                        class="voucher-thumbnail"
                        :initial-index="imgIndex"
                      >
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="body-cell" style="width: 180px;">
                  <div class="cell-content">{{ item.arrivalTime || "-" }}</div>
                </div>
                <div class="body-cell" style="flex: 1;">
                  <div class="cell-content">
                    <el-button type="text" @click="handleEdit(item, 'return')">
                      编辑
                    </el-button>
                    <el-button type="text" @click="handleDelete(item)">
                      删除
                    </el-button>
                  </div>
                </div>
              </div>
              <div v-if="returnList.length === 0" class="empty-row">
                <div class="cell-content">暂无数据</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">返回</el-button>
      </div>
    </el-dialog>

    <!-- 编辑/添加对话框 -->
    <el-dialog
      :title="form.id ? '编辑交通方式' : '添加交通方式'"
      :visible.sync="formVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="dataForm"
        :rules="formRules"
        :model="form"
        label-position="left"
        label-width="120px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="交通方式" prop="means">
              <el-select
                v-model="form.means"
                placeholder="请选择"
                style="width: 100%;"
              >
                <el-option label="火车" value="火车"></el-option>
                <el-option label="飞机" value="飞机"></el-option>
                <el-option label="动车" value="动车"></el-option>
                <el-option label="高铁" value="高铁"></el-option>
                <el-option label="自驾" value="自驾"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车次号/航班号" prop="trainOrFlight">
              <el-input
                v-model="form.trainOrFlight"
                placeholder="请输入车次号/航班号"
                maxlength="50"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="到达时间" prop="arrivalTime">
          <el-date-picker
            v-model="form.arrivalTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择到达时间"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="凭证(支持多张)" prop="vouchersUrl">
          <el-upload
            :action="uploadImgUrl"
            :headers="headers"
            list-type="picture-card"
            :file-list="fileList"
            :on-success="handleUploadSuccess"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doSave()">确认</el-button>
      </div>
    </el-dialog>

    <!-- 图片预览对话框 -->
    <el-dialog
      title="凭证图片"
      :visible.sync="imagePreviewVisible"
      width="800px"
    >
      <div class="image-preview">
        <el-image
          v-for="(url, index) in previewImageList"
          :key="index"
          :src="url"
          :preview-src-list="previewImageList"
          style="width: 200px; height: 200px; margin: 10px;"
          fit="cover"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import meetingSignUpCarryPeopleApi from "@/api/meeting/meetingSignUpCarryPeople";
import meetingSignUpTransportationApi from "@/api/meeting/meetingSignUpTransportation";
import { getToken } from "@/utils/auth";

export default {
  data() {
    return {
      listVisible: false,
      listLoading: false,
      list: [],
      signNo: null,
      currentSignUpNo: null, // 当前查看的交通信息对应的报名号
      detailVisible: false,
      detailLoading: false,
      departureList: [],
      returnList: [],
      currentPersonName: "",
      currentPersonId: null,
      formVisible: false,
      form: {
        id: null,
        signUpNo: "",
        tripType: "departure",
        means: "",
        trainOrFlight: "",
        arrivalTime: "",
        vouchersUrl: ""
      },
      formRules: {
        means: [
          { required: true, message: "请选择交通方式", trigger: "change" }
        ],
        trainOrFlight: [
          { required: true, message: "请输入车次号/航班号", trigger: "blur" }
        ],
        arrivalTime: [
          { required: true, message: "请选择到达时间", trigger: "change" }
        ]
      },
      fileList: [],
      uploadImgUrl: process.env.VUE_APP_BASE_API + "/sys/cosUploader/upload",
      headers: {
        Authorization: "DU " + getToken()
      },
      imagePreviewVisible: false,
      previewImageList: [],
      currentEditIndex: null,
      currentTripType: "departure"
    };
  },
  computed: {
    /**
     * 将列表数据按 parent-child 关系组织
     */
    groupedList() {
      if (!this.list || !Array.isArray(this.list)) {
        return [];
      }
      const result = [];
      const processedIds = new Set();

      // 遍历列表，找出成人和其对应的儿童
      this.list.forEach(item => {
        // 如果已经处理过，跳过
        if (processedIds.has(item.id)) {
          return;
        }

        // 如果是成人（!isChild），创建父级对象
        if (!item.isChild) {
          const parent = { ...item, children: [] };

          // 查找该成人的所有儿童
          // 注意：需要根据实际数据结构判断儿童与成人的关联关系
          // 这里假设通过 parentId 或 signUpNo 关联
          this.list.forEach(childItem => {
            if (
              childItem.isChild &&
              (childItem.parentId === item.id ||
                childItem.signUpNo === item.signUpNo) &&
              !processedIds.has(childItem.id)
            ) {
              parent.children.push(childItem);
              processedIds.add(childItem.id);
            }
          });

          result.push(parent);
          processedIds.add(item.id);
        }
      });

      return result;
    }
  },
  methods: {
    /**
     * 手机号脱敏处理
     */
    maskMobile(mobile) {
      if (!mobile) return "-";
      if (mobile.length === 11) {
        return mobile.substring(0, 3) + "****" + mobile.substring(7);
      } else if (mobile.length > 11) {
        const phonePart = mobile.substring(0, 11);
        const extraPart = mobile.substring(11);
        return (
          phonePart.substring(0, 3) +
          "****" +
          phonePart.substring(7) +
          extraPart
        );
      }
      return mobile;
    },
    /**
     * 身份证脱敏处理
     */
    maskIdCard(idCardNo) {
      if (!idCardNo) return "-";
      if (idCardNo.length > 8) {
        return (
          idCardNo.substring(0, 4) +
          "***********" +
          idCardNo.substring(idCardNo.length - 4)
        );
      }
      return idCardNo;
    },
    /**
     * 打开列表页面
     */
    handleUpdate(row) {
      this.signNo = row.signUpNo;
      this.listVisible = true;
      this.loadList();
    },
    /**
     * 加载携带人员列表
     */
    loadList() {
      if (!this.signNo) {
        this.$message.error("报名号不能为空");
        return;
      }
      this.listLoading = true;
      meetingSignUpCarryPeopleApi
        .fetchListTeev2({
          signNo: this.signNo,
          isGetTransportation: true
        })
        .then(res => {
          if (res && res.data) {
            this.list = res.data || [];
          } else {
            this.list = [];
          }
        })
        .catch(error => {
          this.$message.error(error.msg || "获取列表失败");
          this.list = [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 查看交通信息
     */
    handleViewTransportation(row) {
      this.currentPersonName = row.realName;
      this.currentPersonId = row.id;
      // 保存当前查看的报名号，优先使用 row.signUpNo，如果没有则使用列表页面的 signNo
      this.currentSignUpNo = row.signUpNo || this.signNo;
      this.detailVisible = true;
      this.loadTransportationDetail(this.currentSignUpNo);
    },
    /**
     * 加载交通方式详情
     */
    loadTransportationDetail(signUpNo) {
      this.detailLoading = true;
      meetingSignUpTransportationApi
        .fetchListTeev2({ signUpNo })
        .then(res => {
          if (res && res.data) {
            const allList = res.data || [];
            this.departureList = allList.filter(
              item => item.tripType === "departure"
            );
            this.returnList = allList.filter(
              item => item.tripType === "return"
            );
          } else {
            this.departureList = [];
            this.returnList = [];
          }
        })
        .catch(error => {
          this.$message.error(error.msg || "获取交通方式详情失败");
          this.departureList = [];
          this.returnList = [];
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
    /**
     * 编辑交通方式
     */
    handleEdit(item, tripType) {
      this.form = {
        id: item.id,
        signUpNo: this.currentSignUpNo || this.signNo,
        tripType: tripType,
        means: item.means || "",
        trainOrFlight: item.trainOrFlight || "",
        arrivalTime: item.arrivalTime || "",
        vouchersUrl: item.vouchersUrl || ""
      };
      this.currentTripType = tripType;
      this.fileList = item.vouchersUrl
        ? item.vouchersUrl.split(",").map(url => ({
            url: url,
            name: "凭证图片"
          }))
        : [];
      this.formVisible = true;
      this.$nextTick(() => {
        if (this.$refs["dataForm"]) {
          this.$refs["dataForm"].clearValidate();
        }
      });
    },
    /**
     * 添加交通方式
     */
    handleAdd(tripType, index) {
      this.form = {
        id: null,
        signUpNo: this.currentSignUpNo || this.signNo,
        tripType: tripType,
        means: "",
        trainOrFlight: "",
        arrivalTime: "",
        vouchersUrl: ""
      };
      this.currentTripType = tripType;
      this.currentEditIndex = index;
      this.fileList = [];
      this.formVisible = true;
      this.$nextTick(() => {
        if (this.$refs["dataForm"]) {
          this.$refs["dataForm"].clearValidate();
        }
      });
    },
    /**
     * 删除交通方式
     */
    handleDelete(item) {
      this.$confirm("确认删除该交通方式?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          meetingSignUpTransportationApi
            .deleteTeev2(item.id)
            .then(() => {
              this.$message.success("删除成功");
              this.loadTransportationDetail(
                this.currentSignUpNo || this.signNo
              );
            })
            .catch(error => {
              this.$message.error(error.msg || "删除失败");
            });
        })
        .catch(() => {});
    },
    /**
     * 保存交通方式
     */
    doSave() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          // 提取凭证 URL，支持多种格式
          const vouchersUrl = this.fileList
            .map(file => {
              // 优先使用 file.url
              if (file.url) {
                return file.url;
              }
              // 其次使用 file.response.data
              if (file.response) {
                if (file.response.data) {
                  return file.response.data;
                }
                // 如果 response 本身就是字符串 URL
                if (typeof file.response === "string") {
                  return file.response;
                }
              }
              // 如果 response 是对象且有 url 字段
              if (file.response && file.response.url) {
                return file.response.url;
              }
              return "";
            })
            .filter(Boolean)
            .join(",");
          const params = {
            ...this.form,
            vouchersUrl: vouchersUrl
          };

          meetingSignUpTransportationApi
            .saveTeev2(params)
            .then(() => {
              this.$message.success("操作成功");
              this.formVisible = false;
              // 更新详情对话框中的交通方式列表
              this.loadTransportationDetail(
                this.currentSignUpNo || this.signNo
              );
              // 如果第一个对话框（人员列表）是打开的，重新加载以更新"交通信息"列
              if (this.listVisible) {
                this.loadList();
              }
              // 通知父组件刷新主列表
              this.$emit("created");
            })
            .catch(error => {
              this.$message.error(error.msg || "操作失败");
            });
        }
      });
    },
    /**
     * 上传成功回调
     */
    handleUploadSuccess(response, file, fileList) {
      console.log("上传成功回调:", response, file, fileList);
      // 检查响应格式，支持 code === '0' 或直接有 data 字段
      if (response && (response.code === "0" || response.data)) {
        const imageUrl = response.data || response.url || response;
        // 设置 file 的 url 和 response，确保保存时能正确获取
        if (file) {
          file.url = imageUrl;
          file.response = response;
        }
        // 更新 fileList，确保数据同步
        // 遍历 fileList，找到当前上传的文件并更新其 url
        this.fileList = fileList.map(f => {
          // 如果是当前上传的文件（通过 uid 匹配），更新其 url
          if (f.uid === file.uid) {
            f.url = imageUrl;
            f.response = response;
          }
          return f;
        });
        console.log("更新后的 fileList:", this.fileList);
      } else {
        this.$message.error("图片上传失败");
      }
    },
    /**
     * 移除文件
     */
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    /**
     * 上传前验证
     */
    beforeUpload(file) {
      const isImage = file.type.indexOf("image") !== -1;
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error("只能上传图片文件!");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("图片大小不能超过 5MB!");
        return false;
      }
      return true;
    },
    /**
     * 查看凭证图片
     */
    handleViewVoucher(vouchersUrl) {
      if (!vouchersUrl) return;
      this.previewImageList = vouchersUrl.split(",").filter(Boolean);
      this.imagePreviewVisible = true;
    }
  }
};
</script>

<style scoped>
.transportation-list {
  border: 1px solid #ebeef5;
}

.transportation-header {
  display: flex;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.header-cell {
  padding: 12px;
  text-align: center;
  font-weight: 600;
  color: #606266;
  border-right: 1px solid #ebeef5;
}

.header-cell:last-child {
  border-right: none;
}

.transportation-body {
  max-height: 500px;
  overflow-y: auto;
}

.transportation-row {
  display: flex;
  border-bottom: 1px solid #ebeef5;
  background-color: #fff;
}

.transportation-row.row-even {
  background-color: #fafafa;
}

.transportation-row:hover {
  background-color: #f5f7fa;
}

.body-cell {
  padding: 12px;
  text-align: center;
  border-right: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.body-cell:last-child {
  border-right: none;
}

.cell-content {
  width: 100%;
  word-break: break-word;
  line-height: 1.5;
  color: #6c6c6c;
  font-size: 12px;
}

.name-info {
  color: #000f29;
  font-size: 14px;
}

.empty-data {
  text-align: center;
  padding: 40px;
  color: #909399;
}

.transportation-section {
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
}

.transportation-table {
  border: 1px solid #ebeef5;
}

.table-header {
  display: flex;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.table-body {
  max-height: 400px;
  overflow-y: auto;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #ebeef5;
  background-color: #fff;
}

.table-row:hover {
  background-color: #f5f7fa;
}

.empty-row {
  padding: 40px;
  text-align: center;
  color: #909399;
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.dialog-footer {
  text-align: right;
}

.voucher-images {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  justify-content: center;
}

.voucher-thumbnail {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ebeef5;
}

.voucher-thumbnail:hover {
  border-color: #409eff;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 20px;
}

.transportation-row-wrapper {
  /* border-bottom: 1px solid #ebeef5; */
}

.transportation-row-wrapper:last-child {
  border-bottom: none;
}

.transportation-row.parent-row {
  background-color: #fff;
}

.child-rows-wrapper {
  display: flex;
  padding: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
  border-top: 1px solid #ebeef5;
  background-color: #fafafa;
}

.transportation-row.child-row {
  display: inline-flex;
  justify-content: flex-end;
  background-color: #e8f5fa;
  border: none;
  margin-right: 10px;
}

.transportation-row.child-row .body-cell {
  flex: none;
  padding: 10px;
  border-right: none;
}

.transportation-row.child-row:last-child {
  margin-right: 0;
}
</style>
